"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  list-style: none none;\n  padding: 0;\n  > li {\n    margin: 0 0 20px 0;\n    > strong {\n      font-size: 125%;\n      line-height: 1.3;\n    }\n    > p {\n      margin-top: 5px;\n      color: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefinitionList = void 0;

var styledTypes_1 = require("./styledTypes");

exports.DefinitionList = styledTypes_1.styled.ul(_templateObject(), function (props) {
  return props.theme['@gray-5'];
});